var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div_box",style:('background-color: ' + _vm.bg + ';background-image: url(' + _vm.src + ')')},[_c('div',{staticClass:"div_body"},[_vm._t("default")],2),_c('div-height',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabber),expression:"tabber"}],attrs:{"height":"15vw"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }